import React, { useState, useEffect } from 'react';
import { fetchNotificationsByType } from './services/notificationsService';
import { useNavigate } from 'react-router-dom';
import AddNotificationForm from './addNotificationsData';
import Navbar from './navbar';
import Footer from './footer';

  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const token = window.sessionStorage.getItem("jwtToken");

const NotificationDataManager = ({ type }) => {
  const [notifications, setNotifications] = useState([]);
  const [filteredNotifications, setFilteredNotifications] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [message, setMessage] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);

  const [showFormModal, setShowFormModal] = useState(false);
  const [showStrategyModal, setShowStrategyModal] = useState(false);
  const [selectedStrategy, setSelectedStrategy] = useState("All");
  const [strategies, setStrategies] = useState([]);
  const [modalMessage, setModalMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const token = sessionStorage.getItem("jwtToken");


  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
    fetchStrategies();
  }, [type]);

  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredNotifications(notifications);
    } else {
      setFilteredNotifications(
        notifications.filter(n =>
          n.topic?.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }
    setCurrentPage(1);
  }, [searchTerm, notifications]);

  const fetchData = async () => {
    try {
      const data = await fetchNotificationsByType(type);
      setNotifications(data);
      setFilteredNotifications(data);
      setMessage('');
    } catch (error) {
      setMessage('Failed to fetch notifications.');
    }
  };

  const fetchStrategies = async () => {
    try {
      const res = await fetch(`${BASE_URL}/user/getAllStrategies`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
      const data = await res.json();
      setStrategies(data);
    } catch (err) {
      console.error("Failed to fetch strategies", err);
    }
  };

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredNotifications.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredNotifications.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Notification sending logic
  const handleSendNotificationClick = (item) => {
    setSelectedNotification(item);
    const containsStrategy = item.topic?.toLowerCase().includes("strategy");

  if (containsStrategy) {
    setShowStrategyModal(true);
  } else {
    sendNotification(item.id, item.topic);
  }
  };

const sendNotification = async (id, topic) => {
  try {
    // decide endpoint based on type
    const endpoint =
      type.toLowerCase() === "email"
        ? `${BASE_URL}/user/sendEmailForRebalanced?id=${id}&topic=${topic}`
        : `${BASE_URL}/notifications/sendNotificationsForRebalanced?id=${id}&topic=${topic}`;

    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const result = await response.json();
    setModalMessage(
      result.message ||
        (response.ok ? "Notification sent successfully" : "Failed to send notification")
    );
    setShowModal(true);
  } catch (err) {
    setModalMessage("Error sending notification");
    setShowModal(true);
  }
};


  const sendStrategyNotification = async (id,topic) => {
    if (!selectedNotification) return;
    try {
      const endpoint =
        type === "Email"
          ? selectedStrategy === "All"
            ? `${BASE_URL}/user/sendEmailForRebalanced`
            : `${BASE_URL}/user/sendEmailForRebalanced?id=${id}&strategyName=${selectedStrategy}&topic=${topic}`
          : selectedStrategy === "All"
            ? `${BASE_URL}/notifications/sendNotificationsForRebalanced`
            : `${BASE_URL}/notifications/sendNotificationsForRebalanced?&id=${id}&strategyName=${selectedStrategy}&topic=${topic}`;

      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const result = await response.json();
      setModalMessage(
        result.message ||
          (response.ok ? "Notification sent successfully" : "Failed to send notification")
      );
      setShowModal(true);
      setShowStrategyModal(false);
    } catch (err) {
      setModalMessage("Error sending notification");
      setShowModal(true);
    }
  };

  const handleEditClick = (item) => {
  setSelectedNotification(item);  // store record for editing
  setShowFormModal(true);         // open same modal
};

  return (
    <>
      <Navbar />
      <div className="main-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between mb-3" style={{ marginBottom: '10px', marginTop: '10px' }}>
            <button className="btn btn-primary" onClick={() => navigate(-1)}>Back</button>
            <h4 className="fw-bold">{type} Notifications</h4>
            <button className="btn btn-primary"  onClick={() => {setSelectedNotification(null);setShowFormModal(true);
            }}>Add Notification</button>
          </div>

          <input
            type="text"
            className="form-control mb-3"
            placeholder="Search by topic..."
            value={searchTerm}
             style={{ width: '15%' }}
            onChange={(e) => setSearchTerm(e.target.value)}
          />

          {currentItems.length === 0 ? (
            <p>No notifications available.</p>
          ) : (
            <>
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Topic</th>
                    <th>Type</th>
                    <th>Short Description</th>
                    <th>Long Description</th>
                    <th>Created On</th>
                    <th>Modified On</th>
                    <th>Edit</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((item, index) => (
                    <tr key={index}>
                      <td>{item.title}</td>
                      <td>{item.topic}</td>
                      <td>{item.type}</td>
                      <td>{item.shortDesc}</td>
                      <td style={{ textAlign: "left", width: "800px" }}>{item.longDesc}</td>
                      <td>{item.createdAt}</td>
                      <td>{item.modifiedOn}</td>
                      <td>
                        <button
                          className="btn btn-sm btn-secondary"
                          onClick={() => handleEditClick(item)}
                        >
                          Edit
                        </button>
                      </td>
                      <td>
                        <button
                          className="btn btn-sm btn-success"
                          onClick={() => handleSendNotificationClick(item)}
                        >
                          Send Notification
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <nav className="d-flex justify-content-center mt-3">
                <ul className="pagination">
                  <li className="page-item">
                    <button
                      className="page-link"
                      onClick={() => paginate(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      Previous
                    </button>
                  </li>
                  {[...Array(totalPages)].map((_, idx) => (
                    <li key={idx + 1} className="page-item">
                      <button
                        className={`page-link ${idx + 1 === currentPage ? 'active' : ''}`}
                        onClick={() => paginate(idx + 1)}
                      >
                        {idx + 1}
                      </button>
                    </li>
                  ))}
                  <li className="page-item">
                    <button
                      className="page-link"
                      onClick={() => paginate(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            </>
          )}



          {/* Modal for selecting strategy (Rebalanced Notification) */}
          {showStrategyModal && (
            <div className="modal" style={{ display: 'block' }}>
              <div className="modal-dialog" style={{ maxHeight: '80%', margin: 'auto', marginTop: '100px' }}>
                <div className="modal-content" style={{ backgroundColor: '#e6e8ec' }}>
                  <div className="modal-header">
                    <h5 className="modal-title">Select Strategy</h5>
                    <button type="button" className="btn-close" onClick={() => setShowStrategyModal(false)}></button>
                  </div>
                  <div className="modal-body">
                    <select
                      className="form-select"
                      value={selectedStrategy}
                      onChange={(e) => setSelectedStrategy(e.target.value)}
                    >
                      <option value="All">All Strategies</option>
                      {strategies.map((s, idx) => (
                        <option key={idx} value={s.title}>{s.title}</option>
                      ))}
                    </select>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={() => setShowStrategyModal(false)}>
                      Cancel
                    </button>
                    <button type="button" className="btn btn-primary"   onClick={() => sendStrategyNotification(selectedNotification.id, selectedNotification.topic)}>
                      Send
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Confirmation modal */}
          {showModal && (
            <div className="modal show d-block" tabIndex="-1">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Notification Status</h5>
                    <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                  </div>
                  <div className="modal-body">
                    <p>{modalMessage}</p>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-primary" onClick={() => setShowModal(false)}>
                      OK
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

        
        
          {/* Add/Edit Notification Form Modal */}
          {showFormModal && (
            <div className="modal" style={{ display: 'block' }}>
              <div className="modal-dialog" style={{ maxHeight: '80%', margin: 'auto', marginTop: '100px' }}>
                <div className="modal-content" style={{ backgroundColor: '#e6e8ec' }}>
                  <div className="modal-header">
                    <h5 className="modal-title">
                      {selectedNotification ? 'Edit Notification' : 'Add Notification'}
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => {
                        setShowFormModal(false);
                        setSelectedNotification(null); // clear edit data when closing
                      }}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <AddNotificationForm
                      type={type}
                      editData={selectedNotification}      // <-- pass here
                      onSuccess={() => {
                        fetchData();                       // refresh table
                        setSelectedNotification(null);     // reset
                        setShowFormModal(false);           // close modal
                      }}
                      onClose={() => {
                        setSelectedNotification(null);
                        setShowFormModal(false);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}


        </div>
      </div>
      <Footer />

    </>
  );
};

export default NotificationDataManager;
